import { Box, ColorPicker as ColorPickerBase } from "@wix/design-system";
import React, { useContext, useState } from "react";
import { ModalServiceContext, RicosContext } from "./../../../../../ricos-context/index.js";
import { CUSTOM_COLOR_PICKER } from "./../../../../color-picker/new-color-picker/data-hooks.js";
import {
  Panel,
  PanelHeader,
  useClickOutside,
  usePanelContainerElement
} from "./../../../../index.js";
import { CUSTOM_COLOR_PICKER_MODAL_ID } from "../../constants.js";
import classes from "./custom-color-picker-scss.js";
const getColorHex = (color) => typeof color === "string" ? color : color.hex();
const CustomColorPicker = ({
  currentColor,
  customColors,
  onColorPreviewStart,
  onColorPreviewEnd,
  onColorAdded,
  referenceElement
}) => {
  const { t, isMobile } = useContext(RicosContext);
  const modalService = useContext(ModalServiceContext);
  const containerEl = usePanelContainerElement();
  const [color, setColor] = useState(currentColor?.toUpperCase() ?? "");
  const closeModal = () => modalService.closeModal(CUSTOM_COLOR_PICKER_MODAL_ID);
  const onCloseButtonClick = () => {
    onColorPreviewEnd?.();
    closeModal();
  };
  useClickOutside({
    containerRef: { current: containerEl },
    onClickOutside: (e) => {
      const target = e.target;
      if (target?.dataset?.hook === "tooltip-text" || target?.role === "tooltip" || containerEl.contains(target) || referenceElement?.contains(target)) {
        return;
      }
      onCloseButtonClick();
    }
  });
  return /* @__PURE__ */ React.createElement(
    Panel,
    {
      onCloseButtonClick,
      dataHook: CUSTOM_COLOR_PICKER,
      width: isMobile ? "100%" : 288,
      maxHeight: isMobile ? void 0 : 555,
      height: "fit-content"
    },
    /* @__PURE__ */ React.createElement(PanelHeader, { title: t("Color_Picker_CustomColor_Panel_Title"), className: classes.header }),
    /* @__PURE__ */ React.createElement(
      Box,
      {
        direction: "vertical",
        paddingTop: "SP3",
        paddingLeft: "SP3",
        paddingRight: "SP3",
        paddingBottom: "SP2"
      },
      /* @__PURE__ */ React.createElement(Box, { align: "center", className: classes.customPicker }, /* @__PURE__ */ React.createElement(
        ColorPickerBase,
        {
          allowEmpty: true,
          value: color,
          showConverter: false,
          onChange: (newColor) => {
            const color2 = getColorHex(newColor);
            onColorPreviewStart?.(color2);
            setColor(color2);
          },
          onConfirm: (newColor) => {
            const color2 = getColorHex(newColor);
            if (!customColors.includes(color2)) {
              onColorAdded(color2);
            }
            closeModal();
          },
          onCancel: onCloseButtonClick,
          emptyPlaceholder: t("CustomColorPicker_Empty_Placeholder")
        }
      ))
    )
  );
};
export {
  CustomColorPicker
};
//# sourceMappingURL=custom-color-picker.js.map
